import Vue from 'vue'
import VueRouter from 'vue-router'
import FirstChoice from "@/views/FirstChoice";
import ColorSelection from "@/views/ColorSelection";
import FinitionSelection from "@/views/FinitionSelection";
import HouseType from "@/views/HouseType";
import PilotingSelection from "@/views/PilotingSelection";
import PowerSelection from "@/views/PowerSelection";
import PowerShow from "@/views/PowerShow";
import RegionSelection from "@/views/RegionSelection";
import RoomType from "@/views/RoomType";
import SurfaceSelection from "@/views/SurfaceSelection";
import ThermostatSelection from "@/views/ThermostatSelection";
import TowelSelection from "@/views/TowelSelection";
import OrientationSelection from "@/views/OrientationSelection";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'FirstChoice',
        component: FirstChoice
    }, {
        path: '/color',
        name: 'ColorSelection',
        component: ColorSelection
    }, {
        path: '/orientation',
        name: 'OrientationSelection',
        component: OrientationSelection
    }, {
        path: '/finition',
        name: 'FinitionSelection',
        component: FinitionSelection
    }, {
        path: '/house',
        name: 'HouseType',
        component: HouseType
    }, {
        path: '/piloting',
        name: 'PilotingSelection',
        component: PilotingSelection
    }, {
        path: '/powerSelect',
        name: 'PowerSelection',
        component: PowerSelection
    }, {
        path: '/power',
        name: 'PowerShow',
        component: PowerShow
    }, {
        path: '/region',
        name: 'RegionSelection',
        component: RegionSelection
    }, {
        path: '/room',
        name: 'RoomType',
        component: RoomType
    }, {
        path: '/surface',
        name: 'SurfaceSelection',
        component: SurfaceSelection
    }, {
        path: '/thermostat',
        name: 'ThermostatSelection',
        component: ThermostatSelection
    }, {
        path: '/towelDryers',
        name: 'TowelSelection',
        component: TowelSelection
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/configurator/' : ''
})

export default router
